import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManageRolesPageRoutingModule } from './manage-roles-routing.module';

import { ManageRolesPage } from './manage-roles.page';
import { BhContentSearchComponentModule } from 'src/app/components/_core/bh-content-search/bh-content-search.component.module';
import { BhGridComponentModule } from 'src/app/components/_core/bh-grid/bh-grid.component.module';
import { BhInputComponentModule } from 'src/app/components/_core/bh-input/bh-input.component.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManageRolesPageRoutingModule,
    BhContentSearchComponentModule,
    BhGridComponentModule,
    BhInputComponentModule,
    ReactiveFormsModule
  ],
  declarations: [ManageRolesPage]
})
export class ManageRolesPageModule {}
